import React from "react";
import styled from "styled-components";
const MainCont = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

const NewOrganizer = () => {
  return (
    <MainCont>
      <h1>NewOrganizer</h1>
    </MainCont>
  );
};

export default NewOrganizer;
